import { mergeStyles } from "@fluentui/react";
import { Breakpoint, BreakpointCalculationSign, BreakpointType, GetBreakpoint } from "./ContainerFluid";
import { useMediaQuery } from "react-responsive";

export const containerStylesSM = mergeStyles([{
    width: '100dvw',
    height: '100dvh',
    padding: '.875rem',
    marginRight: 'auto',
    marginLeft: 'auto',
    position: 'relative',
    fontFamily: 'Nunito'
}]);

export const containerStylesMD = mergeStyles([{
    width: '90dvw',
    height: '100dvh',
    padding: '.875rem',
    marginRight: 'auto',
    marginLeft: 'auto',
    position: 'relative',
    fontFamily: 'Nunito'
}]);

export const containerStylesLG = mergeStyles([{
    width: '80dvw',
    height: '100dvh',
    padding: '.875rem',
    marginRight: 'auto',
    marginLeft: 'auto',
    position: 'relative',
    fontFamily: 'Nunito'
}]);

export const containerStylesXL = mergeStyles([{
    width: '70dvw',
    height: '100dvh',
    padding: '.875rem',
    marginRight: 'auto',
    marginLeft: 'auto',
    position: 'relative',
    fontFamily: 'Nunito'
}]);

export const containerStylesXXL = mergeStyles([{
    width: '60dvw',
    height: '100dvh',
    padding: '.875rem',
    position: 'relative',
    fontFamily: 'Nunito',
}]);

export const containerStylesXXXL = mergeStyles([{
    width: '50dvw',
    height: '100dvh',
    padding: '.875rem',
    position: 'relative',
    fontFamily: 'Nunito'
}]);

export const containerCentered = mergeStyles([{
    marginRight: 'auto',
    marginLeft: 'auto'
}]);


export const useBreakpoint = (type: BreakpointType): boolean => {
    const breakpoint: Breakpoint = GetBreakpoint(type);
    return useMediaQuery({ minWidth: breakpoint.minWidth, maxWidth: breakpoint.maxWidth });
};

export const useBreakpointCalculation = (sign: BreakpointCalculationSign, type: BreakpointType, maxWidth?: number, minWidth?: number): boolean => {
    const breakpoint: Breakpoint = GetBreakpoint(type);

    switch (sign) {
        case BreakpointCalculationSign.greaterThan: // Greater Than
            if (maxWidth !== undefined) {
                return breakpoint.maxWidth > maxWidth;
            }
            if (minWidth !== undefined) {
                return breakpoint.minWidth > minWidth;
            }
            return false;
        case BreakpointCalculationSign.lessThan: // Less Than
            if (maxWidth !== undefined) {
                return breakpoint.maxWidth < maxWidth;
            }
            if (minWidth !== undefined) {
                return breakpoint.minWidth < minWidth;
            }
            return false;
        case BreakpointCalculationSign.equalTo: // Equal
            if (maxWidth !== undefined) {
                return breakpoint.maxWidth === maxWidth;
            }
            if (minWidth !== undefined) {
                return breakpoint.minWidth === minWidth;
            }
            return false;
        case BreakpointCalculationSign.greaterThanOrEqual: // Greater Than or Equal
            if (maxWidth !== undefined) {
                return breakpoint.maxWidth >= maxWidth;
            }
            if (minWidth !== undefined) {
                return breakpoint.minWidth >= minWidth;
            }
            return false;
        case BreakpointCalculationSign.lessThanOrEqual: // Less Than or Equal
            if (maxWidth !== undefined) {
                return breakpoint.maxWidth <= maxWidth;
            }
            if (minWidth !== undefined) {
                return breakpoint.minWidth <= minWidth;
            }
            return false;
        case BreakpointCalculationSign.between: // Between
            if (maxWidth !== undefined && minWidth !== undefined) {
                return breakpoint.minWidth > minWidth && breakpoint.maxWidth < maxWidth;
            }
            return false;
        default:
            return false;
    }
};

export const useScreenViewportByBreakpoint = (): BreakpointType => {
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);
    const isXXXL = useBreakpoint(BreakpointType.xxxl);

    if (isSM) {
        return BreakpointType.sm;
    } 
    else if (isMD) {
        return BreakpointType.md;
    }
    else if (isLG) {
        return BreakpointType.lg;
    }
    else if (isXL) {
        return BreakpointType.xl;
    }
    else if (isXXL) {
        return BreakpointType.xxl;
    }
    else if (isXXXL) {
        return BreakpointType.xxxl;
    }
    else {
        return BreakpointType.sm;
    }
}